import React from 'react';
import { Modal } from 'antd-mobile';
import { InformationCircleOutline } from 'antd-mobile-icons';

interface NetworkErrorModalOptions {
  title?: string;
  content?: React.ReactNode;
  onClose?: () => void;
}

/**
 * 显示网络异常提示弹窗
 * @param options 弹窗配置选项
 */
export function showNetworkErrorModal(options: NetworkErrorModalOptions = {}): ReturnType<typeof Modal.show> {
  const {
    title = 'Network Connection Error',
    content = 'No network connection. Please connect to the internet and try again.',
    onClose,
  } = options;
  
  return Modal.show({
    header: (
      <InformationCircleOutline
        style={{
          fontSize: 64,
          color: 'var(--adm-color-warning)',
        }}
      />
    ),
    title,
    content: <div className="text-center">{content}</div>,
    closeOnMaskClick: true,
    onClose,
  });
} 